import { styled } from '@mui/system';
import ColorType from '../Theme/ColorType';
import Footer from '../../routes/Footer';
import { privacySectionsEn, privacySectionsFr } from './PrivacyAndTos';
import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();
  const activeLocale = i18n.resolvedLanguage;
  const privacySections =
    activeLocale === 'en' ? privacySectionsEn : privacySectionsFr;

  return (
    <BodyContainer>
      <Wrapper>
        {privacySections.map((section) => {
          return (
            <StyledLink key={section.id} href={`#section-${section.id}`}>
              {section.title}
            </StyledLink>
          );
        })}
      </Wrapper>
      <TextContainer>
        <SubTitle>{t('last-privacy-update')}</SubTitle>
        <OverflowContainer>
          {privacySections.map((section) => (
            <div
              id={`section-${section.id}`}
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <Text>
                <b>{section.title}</b>
              </Text>
              <Text dangerouslySetInnerHTML={{ __html: section.text }} />
            </div>
          ))}
        </OverflowContainer>
        <FooterContainer>
          <Footer />
        </FooterContainer>
      </TextContainer>
    </BodyContainer>
  );
};

const BodyContainer = styled('div')`
  display: flex;
  flex-direction: row;
  @media (max-width: 535px) {
    flex-direction: column;
  }
`;

const SubTitle = styled('span')`
  font-family: Rubik;
  font-size: 24px;
  font-weight: 500;
`;

const TextContainer = styled('div')`
  flex: 3;
  padding: 70px 100px 40px 60px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 535px) {
    padding: 70px 10px 40px 10px;
  }
`;

const Wrapper = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${ColorType.lightGrey};
  padding: 40px 16px;
`;

const OverflowContainer = styled('div')`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

const Text = styled('span')`
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  // line-height: 120%;
`;

const StyledLink = styled('a')`
  font-family: 'Inter';
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  color: ${ColorType.darkGrey};
`;

const FooterContainer = styled('div')`
  position: relative;
  bottom: 0;
`;

export default Privacy;
